export type NewsletterSenderSettings = {
  senderEmail?: string | null;
  enabledSenderEmails?: readonly string[] | null;
};

const normalizeSenderEmail = (value?: string | null): string =>
  (value || "").trim().toLowerCase();

export const getEnabledNewsletterSenderEmails = ({
  senderEmail,
  enabledSenderEmails,
}: NewsletterSenderSettings): string[] =>
  Array.from(
    new Set(
      [senderEmail, ...(enabledSenderEmails || [])]
        .map(normalizeSenderEmail)
        .filter(Boolean)
    )
  );

/** Preserve saved sender choices until the user explicitly changes them. */
export const reconcileNewsletterSenderEmail = ({
  currentSenderEmail,
  enabledSenderEmails,
}: {
  currentSenderEmail?: string | null;
  enabledSenderEmails: readonly string[];
}): string => {
  const normalizedCurrentSenderEmail = normalizeSenderEmail(currentSenderEmail);

  return normalizedCurrentSenderEmail || enabledSenderEmails[0] || "";
};
